import { ApiClient } from '@webapp/core/services/ApiClient'
import { AuditLogRepository } from './AuditLogRepository'

export const auditLogRepository = new AuditLogRepository({
  httpClient: ApiClient,
})
